var _path, _path2, _path3, _path4, _path5, _g, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 15.8888V41.3585C53 47.1025 46.4119 60.6665 25.8242 60.6665C6.84855 60.6665 1.32495 45.7184 1.32495 41.3586V15.8995C1.32495 13.9532 2.45435 12.1838 4.21975 11.3643L25.1517 1.6477C26.4916 1.0257 28.038 1.028 29.376 1.6541L50.119 11.36C51.8768 12.1825 53 13.948 53 15.8888Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 15.8888V41.3585C53 47.1025 46.4119 60.6665 25.8242 60.6665C6.84855 60.6665 1.32495 45.7184 1.32495 41.3586V15.8995C1.32495 13.9532 2.45435 12.1838 4.21975 11.3643L25.1517 1.6477C26.4916 1.0257 28.038 1.028 29.376 1.6541L50.119 11.36C51.8768 12.1825 53 13.948 53 15.8888Z",
    stroke: "#ECE9F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 18.0323V40.6228C51 45.7924 45.008 58 26.2829 58C9.0239 58 4 44.5467 4 40.6228V18.043C4 16.0894 5.1377 14.3148 6.913 13.4994L25.4982 4.96252C26.8279 4.35172 28.3583 4.35412 29.6861 4.96882L48.1008 13.495C49.8686 14.3135 51 16.0842 51 18.0323Z",
    fill: "#E5B428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0947 19.6301V38.8625C48.0947 43.3601 42.8556 53.981 26.4831 53.981C11.3926 53.981 7 42.2763 7 38.8625V19.6408C7 17.6838 8.1416 15.9068 9.9215 15.0933L25.5424 7.95358C26.8672 7.34808 28.3902 7.35038 29.7131 7.95988L45.1869 15.0889C46.9594 15.9055 48.0947 17.6786 48.0947 19.6301Z",
    fill: "#FFCF45"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_557_158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 21,
    height: 47
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5474 7H7V53.9811H27.5474V7Z",
    fill: "#F9C225"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_557_158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0947 19.6301V38.8625C48.0947 43.3601 42.8556 53.981 26.4831 53.981C11.3926 53.981 7 42.2763 7 38.8625V19.6408C7 17.6839 8.1416 15.9068 9.9215 15.0933L25.5424 7.95358C26.8672 7.34808 28.3902 7.35038 29.7131 7.95988L45.1869 15.0889C46.9594 15.9055 48.0947 17.6787 48.0947 19.6301Z",
    fill: "#F9C225"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85 9.62136L28.9971 13.3373C29.0928 13.6474 29.3771 13.8607 29.7016 13.866L33.3482 13.9251C33.5803 13.9288 33.6824 14.2195 33.5036 14.3676L30.5039 16.8517C30.2758 17.0405 30.1802 17.3459 30.2599 17.6311L31.3467 21.5215C31.4115 21.7537 31.1426 21.9341 30.9523 21.786L28.0719 19.5434C27.8009 19.3325 27.4213 19.3325 27.1504 19.5434L24.2699 21.786C24.0797 21.9341 23.8107 21.7537 23.8756 21.5215L24.9624 17.6311C25.042 17.3459 24.9464 17.0405 24.7184 16.8517L21.7187 14.3676C21.5398 14.2195 21.6419 13.9288 21.874 13.9251L25.5207 13.866C25.8451 13.8607 26.1294 13.6474 26.2251 13.3373L27.3722 9.62136C27.4448 9.38635 27.7774 9.38635 27.85 9.62136Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalGold);
export default __webpack_public_path__ + "static/media/medalGold.32e184848807c1fbd640c9ccc0ceb1d8.svg";
export { ForwardRef as ReactComponent };